var _circle, _circle2, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgManReady = function SvgManReady(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    fill: "#DDEAFA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 57,
    height: 57
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.819 61.232c.053-8.916-4.915-16.22-11.306-17.831-5.693-1.424-10.473 2.148-11.467 2.927v-8.271h-8.808v8.27c-1.074-.751-6.338-4.35-12.541-2.926-7.01 1.61-12.434 8.915-12.38 17.831 10.07-.054 47.29-.054 56.502 0z",
    fill: "#B99EF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.395 51.457-.86 9.775M43.063 52.128l.564 9.104",
    stroke: "#2B292D",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.819 61.232c.053-8.916-4.915-16.22-11.306-17.831-5.693-1.424-10.473 2.148-11.467 2.927v-8.271h-8.808v8.27c-1.074-.751-6.338-4.35-12.541-2.926-7.01 1.61-12.434 8.915-12.38 17.831 10.07-.054 47.29-.054 56.502 0z",
    stroke: "#B99EF4",
    strokeWidth: 1.023,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M33.046 41.897V38.03h-8.808v6.284c.698-.08 8.486-2.337 8.808-2.417z",
    fill: "#2B292D",
    stroke: "#2B292D",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.41 61.5c.053-9.077-4.995-16.516-11.521-18.154-5.8-1.45-10.661 2.202-11.682 2.981v-3.303l-4.323 4.834-4.646-4.834v3.303c-1.101-.779-6.445-4.43-12.783-2.98C4.312 44.983-1.193 52.422-1.14 61.5c10.286-.054 48.177-.054 57.55 0z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.023,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.207 51.54-.86 9.963M43.438 52.238l.564 9.265",
    stroke: "#2B292D",
    strokeWidth: 1.324,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.936 61.473 2.148-8.62h3.062l1.88 8.62h-7.09z",
    fill: "#D9353A",
    stroke: "#D9353A",
    strokeWidth: 0.89,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.393 47.59h6.633l-1.8 5.264h-3.249l-1.584-5.264z",
    fill: "#FF3E44",
    stroke: "#FF3E44",
    strokeWidth: 0.956,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.05 42.624 4.565 4.834-2.256 3.92-5.532-6.552 3.25-2.98-.027.778zM33.153 42.623l-4.538 4.834 2.256 3.921 5.532-6.552-3.25-3.116v.913z",
    fill: "#fff",
    stroke: "#464444",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.397 61.446c8.324 0 15.602.026 19.04.026.053-9.077-4.996-16.515-11.521-18.153-2.847-.725-5.452-.188-7.52.617v17.51zM19.565 43.883c-2.229-.78-5.022-1.236-8.056-.538C4.365 44.985-1.14 52.422-1.086 61.5c3.92-.027 11.843-.027 20.678-.027v-17.59h-.027z",
    fill: "#6565F2",
    stroke: "#6565F2",
    strokeWidth: 1.023,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.561 35.854c7.401 0 13.4-6.24 13.4-13.938 0-7.697-5.999-13.937-13.4-13.937-7.4 0-13.4 6.24-13.4 13.938 0 7.697 6 13.937 13.4 13.937z",
    fill: "#2B292D",
    stroke: "#2B292D",
    strokeWidth: 1.06,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.929 24.923c-.994-.295-2.095.134-2.928 1.074-.322-7.492-5.451-13.427-11.654-13.32-6.096.108-10.984 6.016-11.199 13.347-.805-.672-1.745-.94-2.605-.645-1.557.537-2.255 2.686-1.53 4.834.725 2.148 2.578 3.464 4.135 2.927a2.238 2.238 0 0 0 1.048-.752c1.853 4.888 5.934 8.245 10.607 8.191 4.78-.08 8.835-3.733 10.446-8.862.323.51.78.886 1.316 1.047 1.585.484 3.384-.886 4.055-3.061.645-2.175-.107-4.297-1.691-4.78z",
    fill: "#CAB3FC",
    stroke: "#CAB3FC",
    strokeWidth: 1.175,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M26.01 32.15c-.053 1.933-1.665 3.437-3.625 3.383a3.508 3.508 0 0 1-3.41-3.598C19.027 30 20.64 28.497 22.6 28.55a3.508 3.508 0 0 1 3.41 3.599zM38.283 32.15c-.054 1.933-1.665 3.437-3.626 3.383a3.508 3.508 0 0 1-3.41-3.598c.054-1.934 1.665-3.438 3.625-3.384a3.508 3.508 0 0 1 3.41 3.599z",
    fill: "#9B44D6",
    stroke: "#9B44D6",
    strokeWidth: 1.286,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.55 27.206c0 .726-.403 1.316-.94 1.343-.51 0-.94-.59-.94-1.316 0-.725.403-1.316.94-1.342.51 0 .94.59.94 1.316zM24.828 27.207c0 .725-.43 1.316-.94 1.316s-.94-.59-.94-1.343c0-.725.43-1.316.94-1.316.538.027.94.618.94 1.343z",
    fill: "#09182D",
    stroke: "#09182D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.204 24.2s1.53-1.772 4.592-.51z",
    fill: "#09182D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.177 24.2c.215-.376.564-.672.94-.86.376-.215.805-.322 1.262-.349.43-.027.86.027 1.289.161.215.054.403.134.59.215.189.107.377.215.538.322v.027h-.027l-.564-.215a4.669 4.669 0 0 0-.59-.134 4.578 4.578 0 0 0-1.21-.08 3.6 3.6 0 0 0-1.18.268 4.238 4.238 0 0 0-1.048.645c.027.026.027.026 0 0 0 0 0 .026 0 0zM31.516 23.77s1.88-1.397 4.592.537z",
    fill: "#09182D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.489 23.744c.295-.322.698-.51 1.1-.618.43-.107.86-.107 1.29-.054.43.081.832.215 1.208.43.188.108.35.242.537.35.161.133.323.295.457.429v.027h-.027l-.51-.323c-.188-.08-.35-.188-.537-.268-.376-.161-.752-.295-1.155-.35-.403-.053-.806-.08-1.208 0a3.87 3.87 0 0 0-1.155.377c.027.027.027.027 0 0 0 0 0 .027 0 0zM24.748 30.295c.43.698 1.02 1.262 1.692 1.584.671.323 1.45.403 2.229.43.376 0 .752-.053 1.1-.16.377-.081.726-.243 1.048-.43.323-.189.645-.43.913-.699.296-.268.51-.59.672-.967 0 0 .026-.026.026 0v.027c-.188.806-.778 1.45-1.45 1.907a4.195 4.195 0 0 1-2.31.725c-.805-.027-1.637-.134-2.362-.537-.725-.376-1.262-1.074-1.585-1.826-.027-.054-.027-.054.027-.054-.027-.027-.027-.027 0 0z",
    fill: "#09182D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28.454 27.208-.322 3.142 1.155-.295",
    fill: "#9B44D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.454 27.208-.322 3.142 1.155-.295",
    stroke: "#09182D",
    strokeWidth: 1.091,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "m28.454 27.208-.322 3.142 1.155-.295",
    stroke: "#09182D",
    strokeWidth: 1.091,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.624 27.557 2.202 3.303M42.714 27.557l-2.175 3.303",
    stroke: "#09182D",
    strokeWidth: 0.992,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.938 11.416c-4.806-1.745-9.452-1.1-10.392 1.45-.242.645-.215 1.37.054 2.122-1.155-.537-2.713-.43-4.082.349-2.041 1.181-2.928 3.464-1.988 5.075.94 1.639 3.357 1.988 5.398.806 1.53-.886 2.417-2.39 2.363-3.76 1.263 1.263 3.089 2.417 5.264 3.196 4.807 1.746 9.453 1.101 10.392-1.45.94-2.551-2.202-6.042-7.009-7.788z",
    fill: "#2B292D",
    stroke: "#2B292D",
    strokeWidth: 1.115,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.11 27.636c.189-.134.726-.403 1.451-.403.725 0 1.235.295 1.45.43",
    stroke: "#fff",
    strokeWidth: 1.741,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.165 27.636c-.108 1.934-2.175 3.384-4.566 3.223-2.416-.162-4.27-1.853-4.135-3.787.107-1.933 2.175-3.383 4.565-3.222 2.417.16 4.27 1.853 4.136 3.786zM38.685 27.555c-.107 1.934-2.175 3.384-4.565 3.223-2.417-.162-4.27-1.853-4.136-3.787.108-1.933 2.176-3.383 4.566-3.222 2.39.16 4.243 1.853 4.135 3.786z",
    stroke: "#fff",
    strokeWidth: 1.539,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    fill: "#5F8887",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 28.84v-1.68a2.518 2.518 0 0 1 2.518-2.518h.219c.796.001 1.586-.136 2.335-.404l4.697-4.026a2.518 2.518 0 0 1 1.64-.607c.876 0 1.586.71 1.586 1.587V34.81c0 .876-.71 1.586-1.586 1.586a2.518 2.518 0 0 1-1.64-.607l-4.697-4.026a6.905 6.905 0 0 0-2.335-.404h-.218A2.518 2.518 0 0 1 17 28.84zM36.235 21.752a9.979 9.979 0 0 1 0 12.496 1.32 1.32 0 0 0 2.062 1.652 12.622 12.622 0 0 0 0-15.8 1.32 1.32 0 0 0-2.062 1.652zm-3.744 11.194a1.319 1.319 0 0 0 1.854-.205 7.495 7.495 0 0 0 0-9.482 1.32 1.32 0 1 0-2.059 1.652 4.917 4.917 0 0 1 0 6.178 1.319 1.319 0 0 0 .205 1.857z",
    fill: "#fff"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgManReady);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/man-ready.9d11d3504ca4b24a8e6888b0e09528db.blank.svg";